// extracted by mini-css-extract-plugin
export default {"error":"Image_error__nku0b","clickable":"Image_clickable__sxxjl"};